import { render, staticRenderFns } from "./Knowledge.vue?vue&type=template&id=57ea48aa&scoped=true"
import script from "./Knowledge.vue?vue&type=script&lang=js"
export * from "./Knowledge.vue?vue&type=script&lang=js"
import style0 from "./Knowledge.vue?vue&type=style&index=0&id=57ea48aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57ea48aa",
  null
  
)

export default component.exports